module.exports = __webpack_public_path__ + "static/media/google.6c9520d4.png";